import { textStyles } from '~/themes/textStyles/defaultTextStyles'
import { getShallowObjectKeyMap } from '~/utils/objectUtils'

export type MappedTextStyleKeys = {
  [keyof in keyof typeof textStyles]: keyof typeof textStyles
}
export const textStyleKeys = getShallowObjectKeyMap(
  textStyles,
) as MappedTextStyleKeys
